<template>
  <b-form-group
    label="Departman"
    label-for="id_departments"
  >
    <validation-provider
      #default="{ errors }"
      name="Departman"
      rules="required"
    >
      <v-select
        v-model="dataItem.id_departments"
        :options="dataList"
        label="title"
        :reduce="item => item.id"
        placeholder="Departman"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup,
} from 'bootstrap-vue'
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  name: 'DepartmentSelect',
  components: {
    BFormGroup,
    vSelect,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['departments/dataList']
    },
    dataItem() {
      return this.$store.getters['teams/dataItem']
    },
  },
  created() {
    localize('tr')
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.$store.dispatch('departments/getDataList', {
        select: [
          'departments.id AS id',
          'departments.title AS title',
        ],
        where: {
          'departments.status': 1,
        },
      })
    },
  },
}
</script>
